<template>
  <div class="popup_overlay">
    <div class="popup_content">
      <slot />
    </div>
    <div
      class="close"
      @click="close"
    >
      <img
        src="~/assets/icons/close-white.svg"
        width="14"
        height="14"
        alt="Close icon"
      />
    </div>
  </div>
</template>

<script setup>
  const emit = defineEmits(['close'])

  function close() {
    emit('close')
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .popup {
    &_overlay {
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      height: 100vh;
      left: 0;
      position: absolute;
      top: 0;
      width: 100vw;
      z-index: 10;

      .close {
        cursor: pointer;
        padding: rem(14);
        position: relative;
      }
    }

    &_content {
      background-color: $white;
      padding: rem(16) rem(22);
      width: calc(100% - 90px);
      max-width: 260px;
      z-index: 20;
    }
  }
</style>
